import React from "react"
import { useLocation } from "react-router-dom"

// Componente para adicionar animações de entrada nas páginas
export function PageTransition({ children }) {
  const location = useLocation()

  return (
    <div 
      key={location.pathname}
      className="transition-opacity duration-300 ease-in-out opacity-100"
    >
      {children}
    </div>
  )
}
